'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoNoNewline = function GoNoNewline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 12.5v5h-5v-5l-7.5 7.5 7.5 7.5v-5h7.5s2.5 0 2.5-2.5v-7.5h-5z m-26.2-1.2c-4.9 0-8.8 3.9-8.8 8.7 0 4.8 3.9 8.8 8.8 8.8s8.7-4 8.7-8.8c0-4.8-3.9-8.7-8.7-8.7z m-5 8.7c0-2.8 2.2-5 5-5 0.7 0 1.4 0.2 2 0.4l-6.6 6.6c-0.3-0.6-0.4-1.3-0.4-2z m5 5c-0.8 0-1.5-0.2-2.1-0.4l6.6-6.6c0.3 0.6 0.5 1.3 0.5 2 0 2.8-2.3 5-5 5z' })
        )
    );
};

exports.default = GoNoNewline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/no-newline.js
// module id = 1975
// module chunks = 0